export function snakeToCamelStr(str: string): string {
    return str.replace(/([-_][a-z])/g, (group) =>
        group.toUpperCase()
            .replace('-', '')
            .replace('_', ''),
    );
}

/**
 * converts attribute names from snake_case to camelCase.
 * Deep is recursive.
 * @param obj object to convert
 */
export function snakeToCamelObj(obj: any, deep = false): any {
    if (obj === null || obj === undefined) {
        return obj;
    }

    if (Array.isArray(obj)) {
        return obj.map((v) => snakeToCamelObj(v));
    }

    if (typeof obj === 'object') {
        return Object.keys(obj).reduce((acc: any, key) => {
            acc[snakeToCamelStr(key)] = deep ? snakeToCamelObj(obj[key], true) : obj[key];
            return acc;
        }, {});
    }

    return obj;
}
